import classNames from "classnames";
import { TitleProps } from "./LTitle";

export const LSubTitle = ({ ...props }: TitleProps): JSX.Element => {
    const classes = classNames(
        "subtitle",
        props.size ? `is-${props.size}` : "is-1",
        props.theme === "dark" ? "has-text-white" : props.color ?? "",
        props.verticalSpacing ? `py-${props.verticalSpacing}` : "",
        props.className
    );
    return <h2 className={classes}>{props.children}</h2>;
};
